
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(127|150|806)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
